(function() {
    'use strict';

    angular.module("order")
        .controller('OperationDotpayController', OperationDotpayController);

    OperationDotpayController.$inject = ['momentSrvc', 'operationTypeOptions', 'operationMessagesConst', 'operationDataSrvc', 'downloadLinkSrvc', 'operationSourceOptions', 'notificationSrvc'];

    function OperationDotpayController(momentSrvc, operationTypeOptions, operationMessagesConst, operationDataSrvc, downloadLinkSrvc, operationSourceOptions, notificationSrvc) {
        var self = this;

        self.downloadLoading = false;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.filterData = {
            creation_date_from: null,
            creation_date_to: null,
            type: null,
            source: []
        };

        self.operationTypeOptions = operationTypeOptions;
        self.operationSourceOptions = operationSourceOptions;

        self.getOperations = getOperations;
        self.isPayPal = isPayPal;

        activate();

        function activate() {
        }

        function getOperations() {
            self.downloadLoading = true;
            operationDataSrvc.dotpay(self.filterData).$promise.then(
                function (response) {
                    downloadLinkSrvc.saveFile(response);
                    self.downloadLoading = false;
                },
                function (response) {
                    notificationSrvc.notification("error", operationMessagesConst.downloadError);
                    self.downloadLoading = false;
                }
            )
        }

        function isPayPal() {
            return self.filterData.source.indexOf('paypal') !== -1;
        }

    }
})();
